import { useMutation } from '@tanstack/react-query';
import { api } from '../utils/api';
import { useUserStore } from '../store/userStore';

export const useCompleteWizard = () => {
  const { user, setUser } = useUserStore();
  return useMutation({
    mutationFn: () => api('/users/me/onboarding/complete-wizard', { method: 'POST' }),
    onSuccess: (data) => {
      if (user) setUser({ ...user, onboardingState: data });
    },
  });
};

export const useDismissHint = () => {
  const { user, setUser } = useUserStore();
  return useMutation({
    mutationFn: (hintId: string) =>
      api('/users/me/onboarding/dismiss-hint', { method: 'POST', body: { hintId } }),
    onMutate: async (hintId) => {
      const previous = user?.onboardingState;
      if (user) {
        setUser({
          ...user,
          onboardingState: {
            ...user.onboardingState,
            dismissedHints: [...(user.onboardingState?.dismissedHints || []), hintId],
          },
        });
      }
      return { previous };
    },
    onError: (_err, _hintId, context) => {
      if (user && context?.previous) {
        setUser({ ...user, onboardingState: context.previous });
      }
    },
  });
};

export const useResetOnboarding = () => {
  const { user, setUser } = useUserStore();
  return useMutation({
    mutationFn: () => api('/users/me/onboarding/reset', { method: 'POST' }),
    onSuccess: (data) => {
      if (user) setUser({ ...user, onboardingState: data });
    },
  });
};
